import { useEffect, useState } from 'react';
import { api } from '../../lib/api';

type Props = {
  onToast: (msg: string, kind?: 'ok' | 'err') => void;
  onError: (e: unknown) => void;
};

type IssuerData = {
  legalName: string;
  nif: string;
  address: string | null;
  city: string | null;
  postalCode: string | null;
  country: string | null;
  iban: string | null;
  billingEmail: string | null;
  companyName: string | null;
};

export function Emisor({ onToast, onError }: Props) {
  const [d, setD] = useState<IssuerData | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    void api<{ issuer: IssuerData | null }>('/admin/issuer')
      .then((r) => setD(r.issuer))
      .catch(onError);
  }, [onError]);

  if (!d) return <div className="adm-section"><div className="empty">cargando…</div></div>;

  async function save(e: React.FormEvent) {
    e.preventDefault();
    if (!d) return;
    setBusy(true);
    try {
      await api('/admin/issuer', { method: 'PUT', body: d });
      onToast('Emisor guardado', 'ok');
    } catch (e) {
      onError(e);
    } finally {
      setBusy(false);
    }
  }

  function patch(p: Partial<IssuerData>) {
    setD((cur) => (cur ? { ...cur, ...p } : cur));
  }

  return (
    <form className="adm-section" onSubmit={save}>
      <div className="stitle">Emisor (autónomo)</div>
      <h2>Datos fiscales</h2>
      <div className="row2">
        <div className="field"><label>Nombre legal</label><input value={d.legalName} onChange={(e) => patch({ legalName: e.target.value })} required /></div>
        <div className="field"><label>NIF</label><input value={d.nif} onChange={(e) => patch({ nif: e.target.value })} required /></div>
        <div className="field"><label>Nombre comercial</label><input value={d.companyName ?? ''} onChange={(e) => patch({ companyName: e.target.value })} /></div>
        <div className="field"><label>Email facturación</label><input type="email" value={d.billingEmail ?? ''} onChange={(e) => patch({ billingEmail: e.target.value })} /></div>
        <div className="field"><label>Dirección</label><input value={d.address ?? ''} onChange={(e) => patch({ address: e.target.value })} /></div>
        <div className="field"><label>Ciudad</label><input value={d.city ?? ''} onChange={(e) => patch({ city: e.target.value })} /></div>
        <div className="field"><label>CP</label><input value={d.postalCode ?? ''} onChange={(e) => patch({ postalCode: e.target.value })} /></div>
        <div className="field"><label>País</label><input value={d.country ?? ''} onChange={(e) => patch({ country: e.target.value })} /></div>
        <div className="field"><label>IBAN</label><input value={d.iban ?? ''} onChange={(e) => patch({ iban: e.target.value })} /></div>
      </div>
      <div style={{ marginTop: 14, display: 'flex', justifyContent: 'flex-end' }}>
        <button type="submit" className="btn primary" disabled={busy}>Guardar</button>
      </div>
    </form>
  );
}
